import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const store = ({ auth }) => auth;

const makeSelectLoggedIn = () => createSelector(
  store,
  ({ loggedIn }) => loggedIn,
);

const makeSelectUserInfo = () => createSelector(
  store,
  ({ userInfo }) => userInfo,
);

const makeSelectSession = () => createSelector(
  store,
  ({ session }) => session,
);

export {
  makeSelectSession,
  makeSelectLoggedIn,
  makeSelectUserInfo,
};
